import { useEffect, useState } from 'react';

export function useLoadBingMapScript(src: string) {
  // Keep track of script status ("idle", "loading", "ready", "error")
  type statusValues = 'idle' | 'loading' | 'ready' | 'error';
  const [status, setStatus] = useState<statusValues>(src ? 'loading' : 'idle');
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  const callbackName = 'initMap';
  src = `${src}&callback=${callbackName}`;
  useEffect(() => {
    // Allow falsy src value if waiting on other data needed for
    // constructing the script URL passed to this hook.
    if (!src) {
      setStatus('idle');
      return;
    }
    if (firstLoad) {
      let oldScript: HTMLScriptElement | null = document.querySelector(
        `script[src="${src}"]`
      );
      if (oldScript) {
        oldScript.remove();
      }
      setFirstLoad(false);
    }
    // Fetch existing script element by src
    // It may have been added by another intance of this hook
    let script: HTMLScriptElement | null = document.querySelector(
      `script[src="${src}"]`
    );
    if (!script) {
      // Create script
      script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.type = 'text/javascript';
      script.setAttribute('data-status', 'loading');
      // Add script to document body
      document.body.appendChild(script);
      // Store status in attribute on script
      // This can be read by other instances of this hook
      const setAttributeFromEvent = (event: Event) => {
        (script as HTMLScriptElement).setAttribute('data-status', 'ready');
        setStatus('ready');
      };
      //@ts-ignore
      window[callbackName] = (e: Event) => {
        setAttributeFromEvent(e);
      };
    } else {
      // Grab existing script status from attribute and set to state.
      const newStatus = (script as HTMLScriptElement).getAttribute(
        'data-status'
      ) as statusValues;
      if (newStatus !== status) {
        setStatus(newStatus);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, src]);
  return status;
}
